if (!window.__caAccordionInit) {
  window.__caAccordionInit = true;

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.ca-trigger');
    if (!trigger) return;

    var item = trigger.closest('[data-ca-item]');
    var isOpen = item.classList.contains('is-open');

    item.classList.toggle('is-open', !isOpen);
    trigger.setAttribute('aria-expanded', String(!isOpen));
  });
}